module.exports = __webpack_public_path__ + "static/media/RoundedRect_Quaternary@3x.d72b6e46.png";